
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { DisenioPaginas } from '../../layout';
import { useUsuarioXID } from '../../../hooks';
import { CargandoMedio, FormCreateUpdateUser } from '../../components';
import { useCiudadesStore } from '../../../store';





export const ActualizarUsuario = () => {


    const { id } = useParams();
    const { userXIDQuery } = useUsuarioXID(`${id}`); 
    const usuario = userXIDQuery?.data;
    const { startListadoCiudades } = useCiudadesStore();
    

    useEffect(() => {
        if (usuario?.departamento) {
            startListadoCiudades(usuario.departamento);
        }
    }, [usuario?.departamento]);

    

    const initialState = (usuario) ? {
        nombre: usuario.nombre || "",
        cedula: usuario.cedula || '',
        email: usuario.email || "",
        role: usuario.role || "",
        direccion: usuario.direccion || "",
        departamento: usuario.departamento || '',
        ciudad: usuario.ciudad || "",
        movil: usuario.movil || "",
        id: usuario.id || "",
    } : {};




    return (

        <DisenioPaginas titulo="Actualizar Usuario" url={1} add={false} subtitulo="Eidtar información del usuario">
            {(userXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Usuario..." />
            :   <FormCreateUpdateUser initialState={initialState} />
            }
        </DisenioPaginas>
    )
}
